{
  "portal.title": "Client portal",
  "portal.shell.account": "Your account",
  "portal.shell.signOut": "Sign out",
  "portal.shell.home": "Your projects home",
  "portal.shell.switchLanguage": "Switch to Arabic",
  "portal.shell.otherLanguage": "العربية",
  "portal.shell.footer": "© 404 Creative · Made with care in Cairo and Dubai",
  "portal.shell.secure": "Private to you and the 404 Creative team.",
  "portal.auth.kicker": "404 Creative client portal",
  "portal.auth.headline": "Your project, clear at a glance.",
  "portal.auth.point.journey": "Follow every milestone and the phases inside it.",
  "portal.auth.point.approve": "Review and approve designs and milestones in one tap.",
  "portal.auth.point.talk": "Talk to the team right where the work is.",
  "portal.auth.preview.kickoff": "Kickoff",
  "portal.auth.preview.firstLook": "First look",
  "portal.auth.preview.launch": "Launch",
  "portal.auth.preview.handover": "Handover",
  "portal.auth.preview.wireframes": "Wireframes",
  "portal.auth.preview.visuals": "Visual design",
  "portal.auth.preview.review": "Review",
  "portal.signIn.title": "Welcome back",
  "portal.signIn.subtitle": "Sign in to follow your projects with 404 Creative.",
  "portal.signIn.email": "Email",
  "portal.signIn.submit": "Sign in",
  "portal.signIn.invalid": "That email and password do not match. Check them and try again.",
  "portal.signIn.rateLimited": "Too many attempts. Wait a few minutes, then try again.",
  "portal.signIn.help": "No password yet? Use the invitation link we sent you, or ask your project manager for a new one.",
  "portal.reset.title": "Reset your portal password",
  "portal.reset.subtitle": "Enter the email you use for the portal. If we have it, we will send a 4-digit code.",
  "portal.reset.sentTitle": "Check your email",
  "portal.reset.sentSubtitle": "Enter the 4-digit code we sent to {email}.",
  "portal.reset.newTitle": "Choose a new password",
  "portal.reset.newSubtitle": "Then you will enter the portal, and your other devices will be signed out.",
  "portal.invitation.title": "Welcome to your portal",
  "portal.invitation.subtitle": "{name} invited you to follow your projects with 404 Creative. Choose a password to start.",
  "portal.invitation.subtitleNoInviter": "You are invited to follow your projects with 404 Creative. Choose a password to start.",
  "portal.invitation.name": "Your name",
  "portal.invitation.password": "Choose a password",
  "portal.invitation.passwordHint": "{count, plural, one {At least # character.} other {At least # characters.}}",
  "portal.invitation.accept": "Open my portal",
  "portal.invitation.accepting": "Opening…",
  "portal.invitation.goToSignIn": "Go to sign in",
  "portal.invitation.expired.title": "This invitation has expired",
  "portal.invitation.invalid.title": "This invitation link is not valid",
  "portal.invitation.gone.body": "Ask your project manager at 404 Creative for a new link. If you already chose a password, just sign in.",
  "portal.notFound.title": "We could not find that page",
  "portal.notFound.body": "It may have moved, or it is not shared with you.",
  "portal.notFound.home": "Back to your projects",
  "portal.home.title": "Home",
  "portal.home.greeting": "{greeting, select, morning {Good morning} afternoon {Good afternoon} other {Good evening}}, {name}",
  "portal.home.intro": "Here is where your work with 404 Creative stands today.",
  "portal.home.tile.action": "Waiting on you",
  "portal.home.tile.projects": "Projects",
  "portal.home.tile.progress": "Overall progress",
  "portal.home.needsAction": "Needs your action",
  "portal.home.caughtUp": "You are all caught up",
  "portal.home.caughtUpBody": "We will let you know when something needs your approval.",
  "portal.home.projects": "Your projects",
  "portal.home.noProjects": "No projects yet",
  "portal.home.noProjectsBody": "Your projects appear here as soon as the team starts them.",
  "portal.home.updates": "Recent updates",
  "portal.home.noUpdates": "Nothing new yet",
  "portal.home.noUpdatesBody": "Shared files, approvals and milestones show up here.",
  "portal.home.loadError": "We could not load your projects.",
  "portal.update.approvalRequested": "Your approval was requested on {title}",
  "portal.update.approvalDecided": "{status, select, approved {{title} was approved} changes_requested {Changes were requested on {title}} other {{title} was decided}}",
  "portal.update.milestoneReached": "Milestone reached: {title}",
  "portal.update.fileShared": "New file shared: {title}",
  "portal.service.web": "Website",
  "portal.service.mobile": "Mobile app",
  "portal.service.automation": "Automation",
  "portal.service.marketing": "Marketing",
  "portal.phase.strategy": "Strategy",
  "portal.phase.design": "Design",
  "portal.phase.build": "Build",
  "portal.phase.grow": "Grow",
  "portal.journey.label": "Project journey",
  "portal.journey.currentLabel": "Project journey, now at {label}",
  "portal.journey.now": "Now",
  "portal.journey.state.done": "Finished",
  "portal.journey.state.current": "In progress",
  "portal.journey.state.upcoming": "Coming up",
  "portal.journey.range": "{start} – {end}",
  "portal.journey.phases": "Phases",
  "portal.journey.noPhases": "The team hasn't split this milestone into phases yet.",
  "portal.project.back": "All projects",
  "portal.project.due": "Due {date}",
  "portal.project.progress": "{percent} done",
  "portal.project.nextMilestone": "Next milestone",
  "portal.project.noMilestone": "All milestones reached",
  "portal.project.nowIn": "In progress now",
  "portal.project.views": "Project views",
  "portal.project.tab.milestones": "Milestones",
  "portal.project.tab.work": "Shared work",
  "portal.project.tab.files": "Files",
  "portal.project.noMilestones": "No milestones yet",
  "portal.project.noMilestonesBody": "The team adds the project's milestones as it plans.",
  "portal.project.noWork": "Nothing shared yet",
  "portal.project.noWorkBody": "When the team shares a piece of work with you, you can follow it and discuss it here.",
  "portal.project.noFiles": "No files yet",
  "portal.project.noFilesBody": "Designs, documents and deliverables the team shares with you appear here.",
  "portal.project.loadError": "We could not load this project.",
  "portal.milestone.done": "Reached",
  "portal.milestone.active": "In progress",
  "portal.milestone.late": "Running late",
  "portal.milestone.upcoming": "Upcoming",
  "portal.milestone.dueOn": "Planned for {date}",
  "portal.milestone.reachedOn": "Reached on {date}",
  "portal.stage.planned": "Planned",
  "portal.stage.in_progress": "In progress",
  "portal.stage.done": "Done",
  "portal.task.due": "Due {date}",
  "portal.task.panel": "Shared work",
  "portal.task.files": "Files",
  "portal.task.discussion": "Discussion",
  "portal.task.noComments": "No messages yet. Ask a question or share feedback with the team.",
  "portal.task.loadError": "We could not load this work.",
  "portal.comment.client": "Your team",
  "portal.comment.team": "404 Creative",
  "portal.comment.someone": "Someone",
  "portal.composer.label": "Message to the team",
  "portal.composer.placeholder": "Write to the team… pick a name below to mention someone",
  "portal.composer.attach": "Attach",
  "portal.composer.mention": "Mention someone",
  "portal.composer.removeFile": "Remove {name}",
  "portal.composer.send": "Send",
  "portal.composer.sending": "Sending…",
  "portal.composer.sendError": "We could not send your message. Try again.",
  "portal.composer.uploadError": "We could not upload {name}.",
  "portal.files.openError": "We could not open this file. Try again.",
  "portal.due.today": "Due today",
  "portal.due.inDays": "{days, plural, one {Due tomorrow} other {Due in # days}} · {date}",
  "portal.due.late": "{days, plural, one {# day late} other {# days late}}",
  "portal.approval.review": "Review",
  "portal.approval.approve": "Approve",
  "portal.approval.requestChanges": "Request changes",
  "portal.approval.askedBy": "Asked by {name} {when}",
  "portal.approval.askedOn": "Asked by {name} on {date}",
  "portal.approval.decidedOn": "Decided by {name} on {date}",
  "portal.approval.round": "Round {number}",
  "portal.approval.status.pending": "Waiting for decision",
  "portal.approval.status.approved": "Approved",
  "portal.approval.status.changes_requested": "Changes requested",
  "portal.approval.status.cancelled": "Withdrawn",
  "portal.approval.previewAlt": "Preview of {title}",
  "portal.approval.noInlinePreview": "Open the file to review it.",
  "portal.approval.version": "Version {version}",
  "portal.approval.openFile": "Open file",
  "portal.approval.openPdf": "Open PDF",
  "portal.approval.milestone": "Milestone",
  "portal.approval.milestoneIn": "Milestone · {label}",
  "portal.approval.workDone": "Work done",
  "portal.approval.message": "Message from the team",
  "portal.approval.noMessage": "No message was added.",
  "portal.approval.history": "Rounds",
  "portal.approval.waitingTitle": "Waiting for a decision",
  "portal.approval.waitingOn": "This waits on {name}.",
  "portal.approval.approvedTitle": "Approved",
  "portal.approval.changesTitle": "Changes requested",
  "portal.approval.changesBody": "{name} asked for changes on {date}. The team will share a new round.",
  "portal.approval.cancelledBody": "The team withdrew this request.",
  "portal.approval.loadError": "We could not load this approval.",
  "portal.decision.prompt": "Your decision",
  "portal.decision.promptBody": "Approve to let the team move on, or tell them what to change.",
  "portal.decision.approveTitle": "Approve this?",
  "portal.decision.approveBody": "You are approving {title} as shown. The team will be told right away.",
  "portal.decision.changesTitle": "Request changes",
  "portal.decision.changesBody": "Tell the team what to change in {title}. They will answer with a new round.",
  "portal.decision.noteLabel": "Add a note (optional)",
  "portal.decision.notePlaceholder": "Anything the team should know",
  "portal.decision.changesLabel": "What should change?",
  "portal.decision.changesPlaceholder": "For example: make the logo bigger and use the warmer colours",
  "portal.decision.changesRequired": "Tell the team what to change.",
  "portal.decision.confirmApprove": "Approve",
  "portal.decision.sendChanges": "Send changes",
  "portal.decision.sending": "Sending…",
  "portal.decision.approvedToast": "Approved. Thank you!",
  "portal.decision.changesSent": "Your changes were sent to the team.",
  "portal.decision.error": "We could not record your decision. Try again.",
  "approvals.title": "Approvals",
  "approvals.subtitle": "What the client was asked to approve, and how long the work waited on them.",
  "approvals.loadError": "We could not load the approvals.",
  "approvals.tile.waiting": "Waiting on client",
  "approvals.tile.waitingDays": "{count, plural, one {# day} other {# days}}",
  "approvals.tile.waitingHours": "{count, plural, one {# hour} other {# hours}}",
  "approvals.tile.pending": "Pending",
  "approvals.tile.approved": "Approved",
  "approvals.tile.changes": "Changes requested",
  "approvals.filter.label": "Filter approvals",
  "approvals.filter.all": "All",
  "approvals.status.pending": "Pending",
  "approvals.status.approved": "Approved",
  "approvals.status.changes_requested": "Changes requested",
  "approvals.status.cancelled": "Cancelled",
  "approvals.round": "Round {number}",
  "approvals.empty.title": "No approvals here",
  "approvals.empty.body": "Send a design or a milestone to the client: they approve it from their portal.",
  "approvals.help.title": "How approvals work",
  "approvals.help.snapshot": "What you send is frozen as it is now. A new upload later never changes what the client approved.",
  "approvals.help.rounds": "When the client asks for changes, answer with a new round: the history keeps every round and comment.",
  "approvals.help.clock": "The waiting-on-client clock adds up the time every request waited for an answer.",
  "approvals.row.asked": "Asked {name} {when}",
  "approvals.row.due": "due {date}",
  "approvals.row.waitedDays": "{count, plural, one {Waited # day} other {Waited # days}}",
  "approvals.row.waitedHours": "{count, plural, one {Waited # hour} other {Waited # hours}}",
  "approvals.row.newRound": "New round",
  "approvals.row.roundSent": "New round sent to the client.",
  "approvals.row.cancel": "Cancel request",
  "approvals.row.cancelTitle": "Cancel this request?",
  "approvals.row.cancelBody": "The client will no longer be asked to approve {title}.",
  "approvals.nextRound.title": "Send a new round",
  "approvals.nextRound.description": "The client sees the new version in their portal and decides again.",
  "approvals.nextRound.clientComment": "What the client asked for",
  "approvals.nextRound.versions": "Version {rejected} was turned down. Version {sent} will be sent.",
  "approvals.nextRound.sameVersionTitle": "Upload the changed file first",
  "approvals.nextRound.sameVersionBody": "Version {version} is the one the client turned down. Upload the changed file as a new version, then send the round.",
  "approvals.nextRound.messageLabel": "What changed?",
  "approvals.nextRound.submit": "Send to the client",
  "approvals.nextRound.sending": "Sending…",
  "approvals.request.open": "Request approval",
  "approvals.request.title": "Request approval",
  "approvals.request.description": "The client approves it from their portal. What you send is frozen as it is now.",
  "approvals.request.subjectKind": "What to approve",
  "approvals.subject.file": "A file",
  "approvals.subject.milestone": "A milestone",
  "approvals.request.pickFile": "File",
  "approvals.request.pickMilestone": "Milestone",
  "approvals.request.pickPlaceholder": "Choose…",
  "approvals.request.fileOption": "{name} (v{version})",
  "approvals.request.milestoneOption": "{name} · {date}",
  "approvals.request.titleLabel": "Title",
  "approvals.request.messageLabel": "Message to the client",
  "approvals.request.messageHint": "What should they look at? Keep it short and friendly.",
  "approvals.request.dueLabel": "Reply by",
  "approvals.request.duePlaceholder": "No date",
  "approvals.request.approvers": "Who approves",
  "approvals.request.noApprovers": "Nobody at this client uses the portal yet. Invite a contact from the client's page first.",
  "approvals.request.submit": "Send for approval",
  "approvals.request.sending": "Sending…",
  "approvals.request.sent": "Sent. The client sees it in their portal.",
  "approvals.error.needsClient": "Only a client project's work can be sent for approval.",
  "approvals.error.approvers": "Choose who approves among the client's portal people.",
  "approvals.error.round": "A new round answers a request for changes, once.",
  "approvals.error.sameVersion": "Upload the changed file before sending a new round.",
  "approvals.error.closed": "This request is already closed.",
  "approvals.error.permission": "You do not have permission to do that.",
  "approvals.error.noWhatsApp": "None of the approvers has a WhatsApp or phone number. Add one to their contact.",
  "approvals.whatsapp.share": "WhatsApp",
  "approvals.whatsapp.hint": "Open WhatsApp with a message ready, in the client's language",
  "approvals.share.label": "Share with client",
  "approvals.share.on": "Shared with client",
  "approvals.share.off": "Share with client",
  "approvals.share.onHint": "The client sees this in their portal. Click to keep it to the team.",
  "approvals.share.offHint": "Only the team sees this. Click to show it in the client's portal.",
  "approvals.share.sharedToast": "Shared with the client.",
  "approvals.share.hiddenToast": "Now visible to the team only.",
  "approvals.share.noClient": "This is an internal project: there is no client to share it with.",
  "approvals.share.error": "We could not change who sees this. Try again.",
  "approvals.access.active": "On the portal",
  "approvals.access.invited": "Invited",
  "approvals.access.invite": "Invite to portal",
  "approvals.access.resend": "New link",
  "approvals.access.revoke": "Close portal access",
  "approvals.access.revokeTitle": "Close portal access?",
  "approvals.access.revokeBody": "{name} is signed out at once and can no longer open the portal.",
  "approvals.access.revoked": "Portal access closed.",
  "approvals.access.dialogTitle": "Invite to the client portal",
  "approvals.access.dialogBody": "{name} gets a link to choose a password and follow their projects.",
  "approvals.access.create": "Create invitation",
  "approvals.access.sending": "Creating…",
  "approvals.access.created": "Invitation ready. Send this link to them (it works once, for 7 days).",
  "approvals.access.link": "Invitation link",
  "approvals.access.done": "Done",
  "approvals.access.needsEmail": "Add an email to this contact first.",
  "approvals.access.emailTaken": "Someone else already uses this email.",
  "approvals.role.admin": "Client admin",
  "approvals.role.member": "Client member",
  "approvals.access.emailed": "Invitation emailed. You can also send them this link (it works once, for 7 days)."
}
